import type { IconData } from '@stacksjs/iconify-core'

export const announcementMegaphone: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M42.5 19h-3m-31 0h3m14-17v3M13.479 6.98l2.12 2.122M37.52 6.98l-2.122 2.122m-8.587 3.325c-8.819 7.698-18.314 17.38-21.687 20.87c-.79.817-1.042 2.008-.587 3.048c.248.565.541 1.182.844 1.707s.691 1.087 1.057 1.584c.672.915 1.83 1.291 2.932 1.016c4.709-1.177 17.842-4.558 28.918-8.346\"/><path d=\"M21.612 17.193s2.091 2.092 5.636 8.232s4.311 8.997 4.311 8.997m-8.863 2.935l.594 2.218a4.59 4.59 0 1 1-8.87 2.376l-.494-1.848M26.046 11.1s2.397 2.621 7.166 10.882s5.841 11.647 5.841 11.647\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default announcementMegaphone
